import teamCodeMapping from "assets/flagIndex.json";

const preprocessTeamCodeMapping  = () => {
  const map = {};
  teamCodeMapping.forEach((entry) => {
    const teamData = Object.values(entry)[0];
    teamData.team_name.forEach((name) => {
      map[name.toLowerCase()] = entry;
    });
  });
  return map;
};

const teamCodeHashmap = preprocessTeamCodeMapping ();

export default teamCodeHashmap;
